import { EltType } from 'legacy/lut/classes/models/partner360/ELT/EltType'
import { IELTFinancialData } from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

import { getFinancialDataForGroup } from './getFinancialDataForGroup'
import { getFinancialDataForPartnerId } from './getFinancialDataForPartnerId'

interface IArgs {
  pid: string
  fYear: number
  eltType: EltType
  groupId?: number | null
  forceFetch?: boolean
  isRollup: number
}
export const getFinancialData = async ({
  pid,
  fYear,
  groupId,
  eltType,
  forceFetch,
  isRollup,
}: IArgs): Promise<IELTFinancialData | null> => {
  if (groupId) {
    return getFinancialDataForGroup({ eltType, groupId, fYear, forceFetch, isRollup })
  }
  return getFinancialDataForPartnerId({ eltType, pid, fYear, forceFetch })
}
